import React from 'react'
import { SimplePageHeader, Container, Meta, SocialMedia, BadgeOfficial, BadgeVerified, BadgeMember } from '../../components'
import { DefaultLayout } from '../../layouts'
import { viewportBreakpoint, useViewport } from '../../utils'
import { useLocation } from 'react-router-dom'
import auth from '../../utils/auth'

const Profile = () => {
  const location = useLocation()
  const { isOfficial, isVerified } = auth()
  const isMember= location.search.includes('member')
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const size = isMobile ? '73px' : '140px'

  return (
    <DefaultLayout>
      <SimplePageHeader noPadding/>
      <Container color="#f5f5f5" className="py-8 lg:py-20">
        <div className="flex flex-wrap -mx-4 items-start mb-4 lg:mb-0">
          <div className="w-1/4 lg:w-2/12 px-4">
            <div
              style={{width: size, height: size, backgroundImage: `url('/images/khub_mahmud.jpg')`}}
              className={`rounded rounded-full bg-no-repeat bg-cover bg-center`}
            />
          </div>
          <div className="w-3/4 lg:w-10/12 px-4">
            <h1 className="font-primary font-bold text-2xl lg:text-3xl mb-2 md:mb-5">
              { isOfficial && 'Jawad Mudghofar' }
              { !isOfficial && 'Mahmud Albizar' }
            </h1>

            <div className="md:mb-5">
              {
                isOfficial &&
                <div className="flex items-center">
                  <BadgeOfficial />
                  <p className="ml-2 text-sm text-gray-444">Member of Peacegen Indonesia</p>
                </div>
              }
              {
                isVerified &&
                <div className="flex items-center">
                  <BadgeVerified />
                  <p className="ml-2 text-sm text-gray-444">Verified Member</p>
                </div>
              }
              {
                isMember &&
                <div className="flex items-center">
                  <BadgeMember />
                  <p className="ml-2 text-sm text-gray-444">Member</p>
                </div>
              }
            </div>

            {/* Desktop & Tablet Metas */}
            <div className="hidden md:block">
              <div className="flex flex-wrap -mx-4">
                <div className="w-1/5 px-4">
                  <Meta label="City" value="Bandung, Indonesia"/>
                </div>
                <div className="w-1/5 px-4">
                  <Meta label="Email" value="albizaru@gmail.com"/>
                </div>
              </div>
              {/* <div>
                <Meta label="Organization" value="Peacegen Indonesia"/>
              </div> */}
            </div>
          </div>
        </div>
        {/* Mobile Metas */}
        <div className="md:hidden">
          <div className="w-3/4 ml-auto flex flex-wrap -mx-2 mb-4">
            <div className="w-full mb-4">
              <Meta label="City" value="Bandung, Indonesia"/>
            </div>
            <div className="w-full">
              <Meta label="Email" value="albizaru@gmail.com"/>
            </div>
          </div>
          {/* <div>
            <Meta label="Organization" value="Peacegen Indonesia"/>
          </div> */}
        </div>
      </Container>
      <Container className="pt-10 pb-10 lg:pt-16 lg:pb-16">
        <div className="flex flex-wrap -mx-4">
          <div className="w-full lg:w-9/12 px-4">
            <h4 className="uppercase font-bold text-lg mb-3 lg:mb-5">About Me</h4>
            <div className="blog-content lg:pr-16">
              <p>
                Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.
              </p>
              <img src="/images/khub_profile_about_image.jpg" alt="about"/>
              <p>
                Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.
              </p>
              <p>
                Exercitation veniam consequat sunt nostrud amet. Deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.
              </p>
            </div>
          </div>
          <div className="w-full lg:w-3/12 px-4 mt-5 lg:mt-0">
            <SocialMedia leftOnMobile={true}/>
          </div>
        </div>
      </Container>
    </DefaultLayout>
  )
}

export { Profile }